import React from 'react';
import TransformSection from './common/transform-section';
import InspectorRow from './shared/inspector-row';
import InspectorSection from './shared/inspector-section';
import type { ObjectInspectorProps } from './types';

const FallbackInspector: React.FC<ObjectInspectorProps> = ({ objects, editor }) => {
  const type = objects.length === 1 ? (objects[0].type ?? 'unknown') : `${objects.length} objects`;
  return (
    <>
      <InspectorSection title="Объект">
        <InspectorRow label="Тип">
          <span>{type}</span>
        </InspectorRow>
      </InspectorSection>
      <TransformSection objects={objects} editor={editor} />
    </>
  );
};

export default FallbackInspector;
